import React from 'react';
import Projects from '../components/Projects';
import { Row, Col, Button, Badge, Container } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointDown } from '@fortawesome/free-solid-svg-icons';

import './projects.css';
const ProjectsPage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="projects-hero-section py-5  text-white">
        <Row className="justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
          <Col lg={10} className="text-center">
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              <Badge pill bg="warning" className="mb-3 fs-6">
                🚀 Projects
              </Badge>

              <motion.h1
                className="display-4 fw-bold mb-3"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
              >
                Showcasing Some of My Best Work
              </motion.h1>

              <p className="lead text-light-emphasis">
                A collection of Websites and Web applications that demonstrate my skills and creativity
              </p>
            </motion.div>

            <div className="cta-buttons d-flex justify-content-center gap-3 mt-4 flex-wrap">
              <Button
                variant="outline-warning"
                size="lg"
                href="/services"
                className="cta-button"
              >
                🛠️ My Skills <FaArrowRight className="ms-2" />
              </Button>

              <Button
                variant="outline-info"
                size="lg"
                href="#contact"
                className="cta-button"
              >
                📞 Contact Me <FaArrowRight className="ms-2" />
              </Button>
            </div>
          </Col>
        </Row>
      </section>

      {/* Projects Section */}
      <section className="projects-section py-5 bg-light">
        <div className="container">
            <motion.h2
                    className="section-title text-center mb-5"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    Featured Projects
                  </motion.h2>
       
          <Projects />
        </div>
      </section>

        {/* Contact Section */}
        <section className="py-5 bg-light-section">
  
     
  <Container>
    <Row className="justify-content-center mb-5" id="contact">
      <Col lg={8} className="text-center">
        <h2 className="hero-title mb-3">Let's Connect</h2>
        <p className="section-subtle">
          I'm always open to new opportunities and collaborations
        </p>
      </Col>
    </Row>
    <Row>
    <Col className="text-center">
      {/* Emoji Section */}
      <div className="scroll-indicator text-center my-4">
        <FontAwesomeIcon icon={faHandPointDown} className="finger-icon bounce" />
      </div>
    </Col>
    </Row>
   
  </Container>
</section>
    </>
  );
};

export default ProjectsPage;